// ant design 语言包
import en_US from "antd/es/locale/en_US";
import id_ID from "antd/es/locale/id_ID";
import th_TH from "antd/es/locale/th_TH";
import vi_VN from "antd/es/locale/vi_VN";
import zh_CN from "antd/es/locale/zh_CN";
import es_ES from "antd/es/locale/es_ES";
import ja_JP from "antd/es/locale/ja_JP";
import pt_BR from "antd/es/locale/pt_BR";

export const AntLanguage = {
  "zh-CN": zh_CN,
  "en-US": en_US,
  "id-ID": id_ID,
  "th-TH": th_TH,
  "vi-VN": vi_VN,
  "es-ES": es_ES,
  "ja-JP": ja_JP,
  "pt-BR": pt_BR,
};

export type Language = "zh-CN" | "en-US" | "id-ID" | "th-TH" | "vi-VN" | "es-ES" | "ja-JP" | "pt-BR";

// 语言对应博客地址
export const LanguageMapBlog: { [key: string]: string } = {
  "id-ID": "https://www.kalodata.com/id/blog",
  "en-US": "https://www.kalodata.com/blog",
  "zh-CN": "https://www.kalodata.com/zh/blog",
  "th-TH": "https://www.kalodata.com/th/blog",
  "vi-VN": "https://www.facebook.com/share/g/16bbv9QpWK/",
  "es-ES": "https://www.kalodata.com/blog",
  "ja-JP": "https://www.kalodata.com/jp/blog",
  "pt-BR": "https://www.kalodata.com/blog",
};

// 根据浏览器语言判断决定语言
export const NavigatorLanguage: { [key: string]: string } = {
  id: "id-ID",
  "id-ID": "id-ID", // 兼容 safari
  "zh-CN": "zh-CN",
  th: "th-TH",
  "th-TH": "th-TH", // 兼容 safari
  vi: "vi-VN",
  "vi-VN": "vi-VN",
  es: "es-ES",
  "es-ES": "es-ES", // 兼容 safari
  ja: "ja-JP",
  "ja-JP": "ja-JP", // 兼容 safari
  pt: "pt-BR",
  "pt-BR": "pt-BR", // 兼容 safari
};
